export class CardReview {
	readonly $card: HTMLElement;
	private $content: HTMLElement | null;
	private resizeObserver: ResizeObserver | null = null;
	private ignoreResize = false;

	private readonly classExpanded = 'card-review--expanded';

	constructor(card: HTMLElement) {
		this.$card = card;
		if (!this.$card) return;

		this.init();
	}

	private init(): void {
		this.$content = this.$card.querySelector('.card-review__content');
		if (!this.$content) return;

		this.updateExpandedState();

		this.resizeObserver = new ResizeObserver(() => {
			if (this.ignoreResize) return;

			this.$card.classList.remove(this.classExpanded);
			this.updateExpandedState();
		});
		this.resizeObserver.observe(this.$content);

		this.$card.addEventListener('click', this.toggle);
	}

	private updateExpandedState(): void {
		const overflowing = this.isOverflowing(this.$content);

		if (!this.ignoreResize) {
			if (!overflowing) {
				this.$card.classList.add(this.classExpanded);
			} else {
				this.$card.classList.remove(this.classExpanded);
			}
		}
	}

	private toggle = (): void => {
		this.ignoreResize = true;

		this.$card.classList.toggle(this.classExpanded);

		setTimeout(() => {
			this.ignoreResize = false;
		}, 200);
	};

	private isOverflowing(element: HTMLElement): boolean {
		return element.scrollHeight > element.clientHeight + 1;
	}

	public destroy(): void {
		this.$card.removeEventListener('click', this.toggle);
		this.resizeObserver?.disconnect();
	}
}
